import { render, staticRenderFns } from "./backRegister.vue?vue&type=template&id=128b0822&scoped=true&"
import script from "./backRegister.vue?vue&type=script&lang=js&"
export * from "./backRegister.vue?vue&type=script&lang=js&"
import style0 from "./backRegister.vue?vue&type=style&index=0&lang=less&"
import style1 from "./backRegister.vue?vue&type=style&index=1&id=128b0822&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128b0822",
  null
  
)

export default component.exports